// 4th Street Medical (customType "4thstreetmedical") photo set. Report types:
// 10/11 longevity, 12/13 weight loss, 14/15 performance; anything else
// (stress, unknown) falls back to longevity.
import coverLongevityMale from "./coverLongevityMale.jpg";
import coverLongevityFemale from "./coverLongevityFemale.jpg";
import coverPerformanceMale from "./coverPerformanceMale.jpg";
import coverPerformanceFemale from "./coverPerformanceFemale.jpg";
import coverWeightLoss from "./coverWeightLoss.jpg";
import pillarsLongevityMale from "./pillarsLongevityMale.jpg";
import pillarsLongevityFemale from "./pillarsLongevityFemale.jpg";
import pillarsPerformanceMale from "./pillarsPerformanceMale.jpg";
import pillarsPerformanceFemale from "./pillarsPerformanceFemale.jpg";
import pillarsWeightLossMale from "./pillarsWeightLossMale.jpg";
import pillarsWeightLossFemale from "./pillarsWeightLossFemale.jpg";
import fourthStreetMedicalLogo from "./fourthStreetMedicalLogo.png";

export { fourthStreetMedicalLogo };

type Category = "longevity" | "weightLoss" | "performance";

const categoryOf = (reportType: string): Category => {
  switch (reportType) {
    case "12":
    case "13":
      return "weightLoss";
    case "14":
    case "15":
      return "performance";
    default:
      return "longevity";
  }
};

export const fourthStreetMedicalCoverImg = (
  reportType: string,
  gender?: string
): string => {
  const female = gender === "Female";
  switch (categoryOf(reportType)) {
    case "weightLoss":
      return coverWeightLoss;
    case "performance":
      return female ? coverPerformanceFemale : coverPerformanceMale;
    default:
      return female ? coverLongevityFemale : coverLongevityMale;
  }
};

export const fourthStreetMedicalPillarsImg = (
  reportType: string,
  gender?: string
): string => {
  const female = gender === "Female";
  switch (categoryOf(reportType)) {
    case "weightLoss":
      return female ? pillarsWeightLossFemale : pillarsWeightLossMale;
    case "performance":
      return female ? pillarsPerformanceFemale : pillarsPerformanceMale;
    default:
      return female ? pillarsLongevityFemale : pillarsLongevityMale;
  }
};
